<template>
  <div class="cart_container" ref="cart_container">
    <div class="topcarttmp" :style="{backgroundImage: 'url(' + require('../../assets/images/mb_bg.png') + ')'}">
      <div class="backbtn">
        <backbtn></backbtn>
      </div>
    </div>
    <div class="mobanbox" ref="mobanbox">
      <div class="mobanlist" id="mobanlist">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="mobanlistbox">
            <div v-for="(item,index) in list" :key="index" class="mobancell">
              <dl>
                <dt>
                  <img v-lazy="item.tpl_url" onclick="return false" />
                </dt>
                <dd>
                  <div class="yybtn" v-if="item.is_bind == 0" @click="usemoban" :data-isbind="item.is_bind" :data-id="item.id">应用</div>
                  <div class="yybtn active" v-else>已应用</div>
                </dd>
              </dl>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import backbtn from "../public/backbtn";
import {
  getcarttemplate,
  updateCarttemplate,
  getindexcartMsg
} from "../../api/api";

import Vue from "vue";

import { Dialog, Toast } from "vant";

// 全局注册
Vue.use(Dialog);
Vue.use(Toast);
export default {
  name: "cartemplate",
  components: { backbtn },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 0,
      pageCount: 0
    };
  },
  created () {
    document.title = '名片模板';
    let that = this;
    Toast.loading({
      mask: true,
      message: "加载中..."
    });
    this.gettmpdata();
  },
  mounted () { },
  methods: {
    onLoad () {
      let pageCount = this.pageCount;
      var page = this.page;
      page++;
      this.page = page;
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < pageCount; i++) {
          this.uploadTransaction();
        }
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (this.list.length >= 10) {
          this.finished = true;
        }
      }, 1000);
    },
    //获得模板列表
    gettmpdata () {
      let that = this;
      let page = 0;
      getcarttemplate(page).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.pageCount = res.data.data.pageCount;
          Toast.clear();
        }
      }).catch(err => {
      });
    },
    //加载模板列表
    uploadTransaction () {
      let that = this;
      let page = this.page;
      getcarttemplate(page).then(res => {
        if (res.data.code == 200) {
          let tpmData = res.data.data.list;
          let oldtpmData = that.list;
          tpmData.forEach(item => {
            oldtpmData.push(item);
          });
          that.list = oldtpmData;
        }
      });
    },
    usemoban (e) {
      if (e.currentTarget.dataset.isbind == 0) {
        let ctid = e.currentTarget.dataset.id;
        let that = this;
        Dialog.confirm({
          title: "提醒",
          message: "确定使用此套模板"
        })
          .then(() => {
            // on confirm
            updateCarttemplate(ctid).then(res => {
              if (res.code == 200) {
                Toast.loading({
                  message: "模板应用中..."
                });
                that.gettmpdata();

                //更改主页的背景图
                getindexcartMsg()
                  .then(res => {
                    if (res) {
                      if (res.data.code == 200) {
                        //200-已注册
                        window.localStorage.setItem("bgurl", res.data.data.bg_url)
                      } else {
                        Toast({
                          duration: 2000,
                          message: res.message
                        });
                      }
                    }
                  })
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      } else {
        Toast({
          duration: 2000,
          message: "模板已应用中"
        });
      }
    }
  }
};
</script>

<style scoped>
.cart_container {
  height: 100%;
}
.topcarttmp {
  background-size: 100%;
  background-repeat: no-repeat;
  height: 4.773rem;
  width: 100%;
}

.van-list__loading {
  text-align: center;
}
.mobanbox {
  width: 94%;
  margin: 0 auto;
  padding-top: 0.8108108108108109rem;
}
.mobanbox .mobanlist .van-list .mobanlistbox {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-content: space-between;
  padding-bottom: 0.5rem;
  text-align: center;
}
.mobanbox .mobanlist .mobancell {
  flex: 0 0 48.5%;
  margin-top: 0.64rem;
  margin-bottom: 0.2rem;
}
.mobanbox .mobanlist .mobancell dl dt img {
  width: 100%;
}
.mobanbox .mobanlist .mobancell dl dd {
  padding-top: 0.3rem;
}
.mobanbox .mobanlist .mobancell dl dd .yybtn {
  height: 1.86666rem;
  border: 1px solid #e5e5e5;
  border-radius: 0.3rem;
  color: #ffbd0c;
  text-align: center;
  line-height: 1.86666rem;
  font-size: 0.75rem;
  background: #f5f5f5;
}
.mobanbox .mobanlist .mobancell dl dd .yybtn.active {
  background: #ffbd0a;
  border: 1px solid #ffbd0a;
  color: #fff;
}

.backbtn {
  width: 1.8rem;
  padding-left: 0.8rem;
  padding-top: 1.5rem;
}
.backbtn img {
  width: 1.8rem;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/cartemplate.vue